<div class="content">
  <div class="example-wrap">
    <form
      class="k-form k-form-md"
      [formGroup]="userForm"
    >
      <div class="k-form-buttons">
        @if (user().id) {
          <h2 class="k-form-title">Edit User</h2>
        } @else {
          <h2 class="k-form-title">Add New User</h2>
        }
        <button
          kendoButton
          [svgIcon]="xIcon"
          (click)="cancel()"
          fillMode="flat"
        ></button>
      </div>
      <div class="headerButtons">
        @if (user().id) {
          <button
            kendoButton
            themeColor="secondary"
            (click)="resetPassword($event)"
          >
            Reset Password
          </button>
          <button
            kendoButton
            themeColor="secondary"
            (click)="resetMfa($event)"
          >
            Reset MFA
          </button>
        }
      </div>
      <p class="mt-3">
        <kendo-label
          labelCssClass="k-form-label"
          text="Last Login"
        ></kendo-label>
        {{ user().last_login | date: 'short' }}
      </p>
      <fieldset class="k-form-fieldset">
        <kendo-formfield>
          <kendo-label
            labelCssClass="k-form-label"
            [for]="first_name"
            text="First Name (optional)"
          ></kendo-label>
          <kendo-textbox
            formControlName="first_name"
            #first_name
          ></kendo-textbox>

          <kendo-formhint>New users first name</kendo-formhint>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label
            labelCssClass="k-form-label"
            [for]="last_name"
            text="Last Name (optional)"
          ></kendo-label>
          <kendo-textbox
            formControlName="last_name"
            #last_name
          ></kendo-textbox>

          <kendo-formhint>New users last name</kendo-formhint>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label
            labelCssClass="k-form-label"
            [for]="email"
            text="Email*"
          ></kendo-label>
          <kendo-textbox
            formControlName="email"
            #email
            required
          ></kendo-textbox>

          <kendo-formhint>New users company email address</kendo-formhint>
          <kendo-formerror>Error: Not valid email format</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label
            labelCssClass="k-form-label"
            [for]="role"
            text="Role*"
          ></kendo-label>
          <kendo-dropdownlist
            [defaultItem]="{ text: 'Select Role', value: null }"
            [data]="roleOptions()"
            textField="text"
            valueField="value"
            formControlName="role"
            [valuePrimitive]="true"
            #role
          ></kendo-dropdownlist>
          @if (isPartnerAdmin()) {
            <kendo-formhint>Partner Admin can't be changed here.</kendo-formhint>
          }
        </kendo-formfield>

        <div class="k-form-field">
          <kendo-label
            labelCssClass="k-form-label"
            text="Primary Organization*"
          >
          </kendo-label>
          <cyflare-autocomplete
            [baseUrl]="'v1/organization/administrative/organizationautocomplete/'"
            [textField]="'display_text'"
            [valueField]="'id'"
            [placeholder]="'Search organization...'"
            [showDropdown]="true"
            [completeOnFocus]="false"
            [cacheTtlMs]="2000000"
            [pageSize]="100"
            [lazyScroll]="true"
            [formGroup]="userForm"
            [formValueFieldName]="'primary_organization_id'"
            [defaultItem]="defaultItem"
            [selectedIds]="defaultItem?.id?.toString() || ''"
            (itemSelected)="onOrgDropdownChange($event)"
            (itemCleared)="selectedOrgAccountType.set(null)"
          ></cyflare-autocomplete>
        </div>
        <div class="k-form-field-checkbox-wrap mt-2">
          <kendo-checkbox
            formControlName="add_to_child_org"
            #childOrgCheckbox
          ></kendo-checkbox>
          <kendo-label
            [for]="childOrgCheckbox"
            class="k-checkbox-label"
            text="Add to Child Org"
          ></kendo-label>
        </div>
        @if (showPartnerAccess()) {
          <cyflare-partner-access
            [userId]="user().id"
            [accountType]="selectedOrgAccountType()"
          ></cyflare-partner-access>
        }
        <div class="k-form-buttons">
          @if (user().id) {
            <button
              kendoButton
              themeColor="primary"
              (click)="update($event)"
              [disabled]="userForm.invalid"
            >
              Update User
            </button>
            <button
              kendoButton
              themeColor="error"
              (click)="open()"
            >
              Remove User
            </button>
            @if (opened === true) {
              <kendo-dialog
                title="Delete User"
                (close)="closeDialog('cancel')"
                [minWidth]="250"
                [width]="450"
              >
                <p style="margin: 30px; text-align: center">This action will permanently delete the user and all user data. Are you sure you want to continue?</p>
                <kendo-dialog-actions>
                  <button
                    kendoButton
                    (click)="closeDialog('no')"
                  >
                    Cancel
                  </button>
                  <button
                    kendoButton
                    (click)="delete($event)"
                    themeColor="primary"
                  >
                    Delete
                  </button>
                </kendo-dialog-actions>
              </kendo-dialog>
            }
          } @else {
            <button
              kendoButton
              themeColor="primary"
              (click)="save($event)"
              [disabled]="userForm.invalid"
            >
              Add User
            </button>
            <button
              kendoButton
              (click)="clear()"
            >
              Clear
            </button>
          }
        </div>
      </fieldset>
    </form>
  </div>
</div>
